/*
 * @Author: sail web admin
 * @Date: 2020-04-26 18:07:48
 * @Last Modified by: sail web admin
 * @Last Modified time: 2020-09-27 17:17:47
 * 共用中文
 */

export default {
  Yes: '是',
  No: '否',
  Operate: '操作',
  PleaseEnter: '请输入',
  PleaseChoose: '请选择',
  Inquire: '查询',
  Reset: '重置',
  Submit: '提交',
  New: '新建',
  Ok: '确定',
  Cancel: '取消',
  Edit: '编辑',
  Delete: '删除',
  Detail: '详情',
  Welcome: '欢迎',
  SignIn: '登录',
  SignOut: '退出',
  Close: '关闭',
  All: '全部',
  Export: '导出',
  Collapse: '收起',
  Expand: '展开',
  Upload: '上传',
  Formart: '格式',
  As: '如',
  Enter: '填写',
  SureTo: '确定要',
  NoData: '没有数据！',
  Refresh: '刷新',
  Add: '添加',
  Modify: '修改',
  OperateSuccess: '操作成功',
  OperateFail: '操作失败',
  NetworkFail: '网络异常，请重新操作',
  LoginExpired: '当前用户登录信息已过期，请重新登录！',
  ServerException: '服务器响应异常（状态：002），请重新登录系统！',
  ServerExceptionTryAgain: '服务器响应异常（状态：001），请刷新页面，重新尝试！'
};
